var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-student"},[_c('div',{staticClass:"order-student__middlename"},[_vm._v(" "+_vm._s(_vm.middlename)+" ")]),_c('div',{staticClass:"order-student__part-name"},[_vm._v(" "+_vm._s(_vm.partName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }